import { useMemo } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import ApplicantService from '../../services/applicantService';
import useAbortController from '../useAbortController';

const useApplicantMutation = ({
  organizationId,
  propertyId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  options: MutationOptions,
}) => {
  const applicantService = useMemo(() => new ApplicantService(), []);
  const abortControllerOptions = useAbortController();

  return useMutation(
    ({ id: applicantId, isAdult, ...applicant }) =>
      applicantService.updateApplicant(
        organizationId,
        propertyId,
        applicantId,
        applicant,
        isAdult,
        abortControllerOptions,
      ),
    options,
  );
};

export default useApplicantMutation;
